import React, { forwardRef } from 'react'

import { BaseIconButton, type BaseIconButtonProps } from './BaseIconButton'

interface IconButtonProps
  extends Omit<BaseIconButtonProps, 'children'>, Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'className' | 'children'> {
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ disabled, type = 'button', ...props }, forwardedRef) => {
    return (
      <BaseIconButton {...props}>
        <button
          disabled={disabled}
          ref={forwardedRef}
          type={type}
        />
      </BaseIconButton>
    )
  }
)
